<template>
    <div class="signFile">
        <div class="pro-con-detailss">
            <div class="details-title"><span>签署文件</span></div>
            <div class="file_nav_list">
               <ul class="file_list_box">
                   <li v-for="(item,index) in fileArray" :key="index" :style="{'width':fileArray.length==1?'100%':fileArray.length==2?'50%':fileArray.length==3?'34%':'196px'}" :class="{'active_file':index==curFileind}" @click="changeFileShow(index)">{{item.fileName}}</li>
               </ul>
               <img v-if="fileArray.length>4" :class="['show_more_icon',isShowFileList?'rotateX':'rotateXs']" @click="showFileList(!isShowFileList)" src="../../../../../../assets/images/judicial/bottom_icon.png"/>
            </div>
            <div class="clearboths"></div>
            <div class="file_preview">
                <div v-for="(item,index) in fileArray" :key="index" v-show="index==curFileind" :id="item.id" class="pdfCon"></div>
                <!-- <canvas id="newCanvas" ref="newCanvas" style="display: block;margin: 0 auto;margin-top: 50px;cursor: pointer;" @click="pdfZoom(false)"></canvas> -->
                <!-- <canvas style="cursor: pointer" id="theCanvas" ref="theCanvas" width="100%" height="100%"></canvas> -->
            </div>
        </div>
        <div class="my_seal">
            <div class="my_seal_img">
                <p>我的印章</p>
                <vue-qr v-show="!returnURL" id="code_img" :text="codeValue" ></vue-qr>
                <img  v-show="returnURL" :src="returnURL"/>
                <span v-show="!returnURL">请打开手机上的扫一扫功能，进行手绘签名。</span>
            </div>
            <div class="operations">
                <span>请如实填写个人姓名！</span>
                <button type="button" @click="clearSign">清空签名</button>
            </div>
            <button class="sign_submit" :disabled="issignDisable" @click="signSubmit">签署并确认</button>
        </div>
       <Dialog :visible="isShowmsg"
      :dialogTitle="'消息提示'"
      @closeDialog="closeFaceModal"
      :width="'500px'">
        <div slot="dialog" >
            <p>请上传手写签名</p>
        </div>
        </Dialog>
    </div>
</template>
<script>
import VueQr from "vue-qr";
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
import WebSockt from "@lib/webSocket.js";
import config from "@lib/config.js";
import utils from "@lib/util.js";
export default {
    name:'SignFile',
    props:['notaryApplyId',"user"],
    data(){

        return{
            //当前选项
            curFileind:0,
            //是否显示更多
            isShowFileList:false,
            //当前文件对象
            currentItem: null,
            //文件列表
            fileArray: [],
            //二维码地址 签名h5页面
            codeUrl:"",
            //是否完成手写签名
            showCode:false,
            //签名url
            handCodeUrl:"",
            outTimer:null,
            // pdf
            pdfObject: {
                zoom: false,
                scale: 0.59,
                newScale: 1.4,
                currentIndex: 1,
                totalNumber: 1,
                path: "",
                loading: false
            },
            
            imageUrls: require("@image/sign/qrcode.png"),
            returnURL: "",
            sealId:"",
            isShowmsg:false,
            issignDisable:false,
        }
    },
    components:{VueQr},
    methods:{
        closeFaceModal(){

        },
        initWebsocket() {
            let webSocket = new WebSockt(
                this.$sotre,
                `${config.webSocketUrl}/ws/seal/${localStorage.token ||
                "Tnur5Z01dIINOpTFyv00y8vylkQepF"}`,
                (data, ws) => {

                data = JSON.parse(data).datas;
                this.sealId=data.id
                this.returnURL = data.fileUrl;
                localStorage.setItem('codeurl',data.fileUrl);
            }
        );
        webSocket.wsAddEvent();
        },
        //选择预览文件
        changeFileShow(index){
            this.curFileind=index;
            this.activeChange('',this.fileArray[index])
        },
        //清空签名
        clearSign(){
            this.returnURL="";
            localStorage.removeItem('codeurl');
            // this.getSignCodeUrl();
        },
        activeChange(node, item) {
            this.currentItem = (node && node.$attrs.item) || item;
            if (!this.currentItem.isAdd) {
                this.currentItem.isAdd = true;
                this.$nextTick(() => {
                    this.getPdfToImage(this.currentItem.getPath,this.currentItem.id);
                });
            }
        },
        //显示更多
        showFileList(flag){
            if(this.fileArray.length>4){
                this.isShowFileList=flag;
                if(flag ){
                    $('.file_list_box').animate({
                        'height':Math.ceil(this.fileArray.length/4)*48 +'px'
                    },200)
                }else{
                    $('.file_list_box').animate({
                        'height':'48px'
                    },200)
                }
            }
        },
        getPage(page, index, id) {
            var scale = 1; //缩放倍数，1表示原始大小
            var viewport = page.getViewport(scale);
            var canvas = document.getElementById("canvas" + index + id);
            var canvasFather = canvas.parentNode;
            var context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            canvasFather.style.width = viewport.width + "px";
            canvasFather.style.height = viewport.height + "px";
            canvasFather.style.margin = "10px auto";
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.render(renderContext).promise.then(() => {
                this.loadedPageCount++;
            });
        },
        //加载pdf文件
        getPdfToImage(url, id) {
            let herfPash = window.location.href.split("//")[0]+"//"+window.location.href.split("//")[1].split("/")[0];
            // let path =herfPash+url.substring(url.indexOf(".com") + 4);
            let path =url;
            let container = document.getElementById(id);
            container.style.display = "block";
            let _this = this;
            url =
                path ||
                "http://xcon-dev.oss-cn-beijing.aliyuncs.com/0120190110001451/20190110/50.pdf";
                // console.log(url ,'pdf 的地址')
            PDFJS.getDocument(url).then(function getPdfHelloWorld(pdf) {
                _this.totalPage = pdf.numPages;
                for (let i = 1; i <= _this.totalPage; i++) {
                $(container).append(
                    `<div class="canvasBoxFlag" data-pageIndex=${i} id="canvasBoxFlag${i}${id}"><canvas data-pageIndex=${i} class="canvasContent" id="canvas${i}${id}"></canvas></div>`
                );
                pdf.getPage(i).then(page => {
                    _this.getPage(page, i, id);
                });
                }
                $(".canvasBoxFlag").addClass("canvasBox");
                $(".pdfPageFlag").addClass("pdfPage");
            });
        },
        //提交
        signSubmit(){
            if( this.returnURL){
                
            }else{
              this.isShowmsg=true;
              this.issignDisable=false;
                return;
            }
            let str=this.fileArray.map((item)=>{
               return item.id;
            })
            if(str.length){
                 this.$emit('signSubmit',{
                    notaryApplyId:this.notaryApplyId,//公证id
                    // uuid:this.notaryApplyId,//签名传递的uuid
                    // uid:this.user.currentUserId,
                    // loginAccount:this.user.person.mobile,
                    sealId:this.sealId,
                    // notaryFiles:str.join(",")//签约文件id
                })
            }else{
                 this.issignDisable=false;
            }
        },
        //轮询获取手写签名
        // getSignCodeUrl(){
        //         BaseApi.createRpcToken("/judicial/gdgz/getFileSingOssUrl",{
        //                 uuid: this.notaryApplyId
        //             }, "POST").then(response => {
                   
        //             this.outTimer = setTimeout(() => {
        //                 if(!localStorage.getItem('codeurl')){
        //                     localStorage.setItem('codeurl',response.data.url?response.data.url.split("?")[0]:"false")
        //                 }
        //                 if(response.data.url){
        //                     if(response.data.url.split("?")[0]==localStorage.getItem('codeurl')){
        //                         this.getSignCodeUrl();
        //                     }else{
        //                         this.handCodeUrl=response.data.url;
        //                         this.showCode=true;
        //                         clearTimeout(this.outTimer)
        //                     }
        //                 }else{
        //                    this.getSignCodeUrl();
        //                 }
        //             }, 1000)  
        //         })
        // },
        getNotaryFile(){
               BaseApi.createRpcToken("/notaryApply/getNotarySignFile",{
                        notaryApplyId: this.notaryApplyId
                    }, "POST").then(res=>{
                    if(res.code==200){
                        this.fileArray=res.datas.list;
                        this.fileArray.forEach(item=>{
                            item.id=utils.getUID();
                        })
                        if(this.fileArray.length){
                            this.activeChange('',this.fileArray[0]);
                        }   
                    }
                })
        }
    },
    created(){
        this.codeUrl=window.location.origin +"/m/canvasSign-notarization?notaryApplyId="+this.notaryApplyId+"&token="+this.user.currentUserId+"&signtype=1";
        
    },
    mounted(){
        this.initWebsocket();
        localStorage.removeItem('codeurl');
        this.getNotaryFile();
        // this.getSignCodeUrl();
    },
    computed:{
        codeValue(){
           return `${config.mobileSignUrl}/m/canvasSign?token=${localStorage.token ||"Tnur5Z01dIINOpTFyv00y8vylkQepF"}&username=${this.username}`
        },
        username(){
            return  encodeURI(this.$store.state.userInfo && this.$store.state.userInfo.person.realName)
        }
    }
};
</script>
<style scoped lang="scss">
.signFile{
    width: 100%;
    height: 100%;
}
.pro-con-detailss {
  margin: 0 auto;
//   border: 1px solid #e4e4e4;
  /*border-radius: 4px;*/
//   background-color: #f9f9f9;
  color: #464646;
  position: relative;
  
}
.details-title {
    display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 46px;
  padding: 0 15px;
  border: 1px solid #e4e4e4;
//   border-bottom: 1px solid #e4e4e4;
  background: url(../../../../../../assets/images/judicial/arrow.png) no-repeat #f9f9f9;
  background-position: 15px 19px;
  padding-left: 32px;
  span:nth-child(2){
    font-size: 14px;
    font-weight: 500;
    color: #A0A0A0;
  }
}
.file_nav_list{
    width: 100%;
    position: absolute;
    top: 46px;
    z-index: 9;
    ul {
        width: 100%;
        height:48px;
        overflow: hidden; 
        border: 1px solid #E4E8EB;
        border-top: 0px;
        background: #F7F7F7;
        box-sizing: border-box;
        li{
            width: 196px;
            height: 48px;
            border-bottom: 1px solid #E4E8EB;
            font-size: 12px;
            font-weight: 400;
            color: #646464;
            line-height: 48px;
            float: left;
            text-align: center;
            border-right: 1px solid #E4E8EB;
            cursor: pointer;
            box-sizing: border-box;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .active_file{
            background: #FFFFFF;
            font-weight: 600;
            color: #CE130E;
        }
    }
    .show_more_icon{
        width: 48px;
        position: absolute;
        top: 0px;
        height: 48px;
        right: 0px;
        cursor: pointer;
        z-index: 10;
    }
    .rotateX{
            transform: rotateX(180deg);
            transition:.5s;
    }
    .rotateXs{
            transform: rotateX(0deg);
            transition:.5s;
    }
}
.clearboths{
    height: 48px;
}
.file_preview{
    height: 564px;
    overflow-y:auto;
    padding: 0px;
    // overflow: hidden;
    background: #E2E2E2;
}
.my_seal{
    width: 830px;
    margin: 0 auto;
    padding-bottom: 50px;
    .my_seal_img{
        text-align: center;
        width: 100%;
        height: 295px;
        background: #FFFFFF;
        border: 1px solid #E4DFDF;
        margin-top: 20px;
        p{
            width: 100%;
            text-align: left;
            padding: 20px 0px 0px 20px;
            font-size: 18px;
            color: #646464;
        }
        img{
            width: 120px;
            height: 120px;
            margin: 0 auto;
            margin-top: 30px;
        }
        span{
            font-size: 14px;
            color: #646464;
            display: block;
            text-align: center;
            width: 100%;
        }
    }
    .operations{
        width: 100%;
        height: 38px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0px 20px 0px;
        span{
            font-size: 13px;
            color: #B4B4B4;
        }
        button{
            width: 105px;
            height: 38px;
            background: #FFFFFF;
            border-radius: 19px;
            border: 1px solid #CE130E;
            font-size: 16px;
            color: #CE130E;
            cursor: pointer;
        }
    }
    .sign_submit{
        width: 240px;
        height: 44px;
        background: #F4F4F4;
        border: 1px solid #D0D0D0;
        font-size: 16px;
        color: #767676;
        display: block;
        margin: 0 auto;
    }
    .sign_submit:hover{
        background: #D81212;
        border: 1px solid #D81212;
        font-size: 16px;
        color: #ffffff;
    }
}
</style>